module.exports = __webpack_public_path__ + "static/img/RO.4ebbd9df.svg";